import React from 'react';
import { Search, User, Sliders } from 'lucide-react';
import { AppTab } from '../types';
import { tg } from '../services/telegram';
import { CassetteReelIcon } from './icons/HardwareIcons';

interface BottomNavProps {
  activeTab: AppTab;
  onTabChange: (tab: AppTab) => void;
  favoritesCount: number;
}

export const BottomNav: React.FC<BottomNavProps> = ({
  activeTab,
  onTabChange,
  favoritesCount,
}) => {
  const tabs: Array<{
    id: AppTab;
    label: string;
    icon: (isActive: boolean) => React.ReactNode;
    badge?: number;
  }> = [
    {
      id: 'deck',
      label: 'Дека',
      icon: (isActive) => (
        <span className={`nav-reel-icon ${isActive ? 'spinning' : ''}`}>
          <CassetteReelIcon size={18} color={isActive ? 'var(--amber)' : 'currentColor'} />
        </span>
      ),
    },
    {
      id: 'search',
      label: 'Поиск',
      icon: (isActive) => (
        <Search
          size={18}
          color={isActive ? 'var(--amber)' : 'currentColor'}
          strokeWidth={isActive ? 2.3 : 1.8}
        />
      ),
    },
    {
      id: 'profile',
      label: 'Кабинет',
      badge: favoritesCount > 0 ? favoritesCount : undefined,
      icon: (isActive) => (
        <User
          size={18}
          color={isActive ? 'var(--amber)' : 'currentColor'}
          strokeWidth={isActive ? 2.3 : 1.8}
        />
      ),
    },
    {
      id: 'settings',
      label: 'Настройки',
      icon: (isActive) => (
        <Sliders
          size={18}
          color={isActive ? 'var(--amber)' : 'currentColor'}
          strokeWidth={isActive ? 2.3 : 1.8}
        />
      ),
    },
  ];

  return (
    <nav className="bottom-nav" aria-label="Основная навигация">
      <div className="bottom-nav-inner">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              type="button"
              className={`bottom-nav-item ${isActive ? 'active' : ''}`}
              onClick={() => {
                tg.haptic('light');
                onTabChange(tab.id);
              }}
              aria-selected={isActive}
            >
              <div className="bottom-nav-icon-wrap">
                {tab.icon(isActive)}
                {tab.badge !== undefined && (
                  <span className="bottom-nav-badge">{tab.badge > 99 ? '99+' : tab.badge}</span>
                )}
              </div>
              <span className="bottom-nav-label">{tab.label}</span>
              {isActive && <span className="bottom-nav-indicator" />}
            </button>
          );
        })}
      </div>
    </nav>
  );
};
